import {
  getRemoteEntriesForEnvironment,
  mfeRegistry,
  requireFirebaseHosting,
} from '../../../../../config/mfe.registry';

import type { Environment } from './environment.model';
import { GOOGLE_CLIENT_ID } from './google.env';

const stage = mfeRegistry.host.environments.development;
const firebaseHosting = requireFirebaseHosting(stage);

export const environment = {
  production: false,
  runtimeEnvironment: 'development',
  apiUrl: 'https://api.edsis.dev',
  deployment: {
    url: stage.origin,
    branch: mfeRegistry.stages.development.branch,
    firebaseProject: firebaseHosting.project,
  },
  google: {
    clientId: GOOGLE_CLIENT_ID,
  },
  remotes: getRemoteEntriesForEnvironment('development'),
} satisfies Environment;
